import { Ban } from "lucide-react";

function ApiError() {

  return (
    <div className='w-full h-[500px] flex items-center justify-center border rounded-md'>
      <div className='flex items-center justify-center gap-2'>
        <Ban className="mr-2 h-10 w-10 text-rose-700" />
        <h6>No services</h6>
      </div>
    </div>
  );
}

export default ApiError;
